import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const CalendarCheckIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path d="M7.61539 9.84V11.36H6.07692V9.84H7.61539Z" fill="#222" />
          <path
            d="M16.8462 6.04V11.9924C16.7317 11.9854 16.6163 11.9818 16.5 11.9818C16.0907 11.9818 15.6917 12.0261 15.3077 12.1102V9.08H4.53846V16.68H11.0234C10.9827 16.9504 10.9615 17.2273 10.9615 17.5091C10.9615 17.7431 10.9761 17.9737 11.0044 18.2H4.53846C3.68462 18.2 3 17.516 3 16.68L3.00769 6.04C3.00769 5.204 3.68462 4.52 4.53846 4.52H5.30769V3H6.84615V4.52H13V3H14.5385V4.52H15.3077C16.1538 4.52 16.8462 5.204 16.8462 6.04ZM4.53846 7.56H15.3077V6.04H4.53846V7.56Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M13.7692 11.36V9.84H12.2308V11.36H13.7692zM9.15385 11.36H10.6923V9.84H9.15385V11.36zM18.1218 15.8657L15.7987 18.1495 14.8783 17.2446 14.205 17.9064 15.7987 19.4732 18.795 16.5276 18.1218 15.8657z"
            fill="#222"
          />
          <path
            d="M16.5 22C18.9853 22 21 19.9894 21 17.5091C21 15.0288 18.9853 13.0182 16.5 13.0182C14.0147 13.0182 12 15.0288 12 17.5091C12 19.9894 14.0147 22 16.5 22ZM16.5 20.5565C18.1864 20.5565 19.5536 19.1921 19.5536 17.5091C19.5536 15.8261 18.1864 14.4617 16.5 14.4617C14.8136 14.4617 13.4464 15.8261 13.4464 17.5091C13.4464 19.1921 14.8136 20.5565 16.5 20.5565Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
